import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { manageDsrZoomLink } from '../../organizations/actions/zoom-actions';
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton';

function DsrCreateZoomLinkButton({
  //Parent Component
  dsrId,
  // Actions
  manageDsrZoomLink,
  // Redux
  authorisedExternalIntegrations
}) {

  const { authorisedZoom } = authorisedExternalIntegrations || {}
  const [isLoading, setIsLoading] = useState(false)


  const createZoomLinkForDsr = () => {
    manageDsrZoomLink({
      sourceEvent: "create-zoom-link",
      dsrId
    })
    setIsLoading(true)
  }

  if (authorisedZoom) {
    return (
      <LaunchdeckButton bg='white' color='brandDark.500' border='1px dotted' borderColor='gray.500' px='5em' w={["100%", "100%", "auto", "auto"]} loadingLogic={isLoading} onClick={() => createZoomLinkForDsr()} label='Create Zoom Link' />
    );
  }
};


function mapStateToProps(state) {
  return {
    authorisedExternalIntegrations: state.authorisedExternalIntegrationsConfig.results
  };
}


const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      manageDsrZoomLink
    },
    dispatch,
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DsrCreateZoomLinkButton));
